import 'babel-polyfill'
import React from 'react'
import { render } from 'react-dom'
import moment from 'moment-timezone'
import { browserHistory } from 'react-router'
import { syncHistoryWithStore } from 'react-router-redux'
import withScroll from 'scroll-behavior'

import Analytics from './utils/analytics'
import Raven from './utils/raven'
import Root from './containers/root'
import configureStore from './store/configure-store'
import routes from './routes'

const initialState = window.__INITIAL_STATE__  // eslint-disable-line no-underscore-dangle
const store = configureStore(initialState)
const history = withScroll(syncHistoryWithStore(browserHistory, store))

const state = store.getState()
if (state.settings && state.settings.release) {
  Raven.setRelease(state.settings.release)
}
if (state.settings && state.settings.timezone) {
  moment.tz.setDefault(state.settings.timezone)
}

Analytics.init(history, routes)

render(
  <Root history={history} store={store} />,
  document.getElementById('root')
)



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/